import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import ConsentBanner from '../components/ConsentBanner';
import LegalLinks from '../components/LegalLinks';
import s from './ThankYouPage.module.css';

// /subscribed, where Stripe Checkout returns on success (#754): the
// deployment's STRIPE_CHECKOUT_SUCCESS_URL, with `?session_id=` that Stripe
// fills in (functions/billing/README.md). src/lib/adConversions.js counts the
// paid conversion from that id, once, and useThankYouPages takes it out of the
// address; this component only draws the screen.
//
// Not behind the Paywall: a studio whose trial had ended comes back here
// before Stripe's webhook has reached the server, and its billing record still
// says lapsed for a few seconds. A locked screen as the thank-you for paying
// would be the wrong first impression.
//
// The words promise nothing this page cannot see. Whether the card is charged
// today depends on whether the trial is still running (a card added in the
// trial is charged when it ends), and Membership, one click away, is where the
// app says which, with the date.
//
// Not an MMS parity element: the page exists for conversion measurement, and
// its copy is ours.
export default function SubscribedPage() {
  return (
    <main className={s.page}>
      <div className={s.card}>
        <div className={s.mark} aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
            <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h1 className={s.title}>You&rsquo;re subscribed</h1>
        <p className={s.body}>
          Thank you. Your card is saved and your subscription is set up. If your free
          trial is still running, nothing is charged until it ends.
        </p>
        <p className={s.body}>Membership, in Settings, shows your plan and your receipts.</p>
        <div className={s.actions}>
          <Link to="/">
            <Button variant="primary">Go to your studio</Button>
          </Link>
          <Link to="/settings#membership">
            <Button variant="secondary">See Membership</Button>
          </Link>
        </div>
      </div>
      <div className={s.banner}>
        <ConsentBanner inline />
        <LegalLinks cookieSettings />
      </div>
    </main>
  );
}
